import { useRouteError } from "react-router-dom";
import toby from './annoyingdog.gif'
import './error.css'

function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error">
      <h1>Oops!</h1>
      Something went wrong. Sorry!
      <p id='small'>
        Error: <i>{error.statusText || error.message}</i>
      </p>
      <img src={toby} id='tobydog'/>
    </div>
  );
}

export default ErrorPage;